"use strict";

var createReducer = require('./reduceComponentFields');

function priceFunctionsReducer(priceFunctions, order, options) {
  var reducer = createReducer(order, null, {}, null, {}, {}, options);
  return priceFunctions.reduce(reducer, 0);
}

function reduceOrderFields(order, priceFunctions, options) {
  return priceFunctionsReducer(priceFunctions, order, options);
}

module.exports = reduceOrderFields;